import {
  createEventCallbackRedirect,
  EVENT_TIMEOUT_IN_MS,
  sendGAEvent,
} from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { carouselVisible, clickCarouselLink, navigateCarousel } from '../modules/actions';
import { LinkCarouselType } from '../types';
import {
  CarouselNavigationImpression,
  CarouselVisibleImpression,
  LinkClickImpression,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [clickCarouselLink.type]: (_prevState, _nextState, action) => {
    const { payload } = action as ReturnType<typeof clickCarouselLink>;
    const { link, carouselType } = payload;

    sendGAEvent<LinkClickImpression>({
      event: 'custom_event',
      event_category: carouselType as LinkCarouselType,
      event_action: 'Link Click',
      event_label: link.title!,
      eventCallback: createEventCallbackRedirect(link.rel!),
      eventTimeout: EVENT_TIMEOUT_IN_MS,
    });
  },
  [navigateCarousel.type]: (_prevState, _nextState, action) => {
    const { payload } = action as ReturnType<typeof navigateCarousel>;
    const { navigation, carouselType } = payload;

    sendGAEvent<CarouselNavigationImpression>({
      event: 'custom_event',
      event_category: carouselType as LinkCarouselType,
      event_action: navigation.type,
      event_label: navigation.direction,
    });
  },
  [carouselVisible.type]: (_prevState, _nextState, action) => {
    const { payload } = action as ReturnType<typeof carouselVisible>;
    const { carouselType } = payload;

    sendGAEvent<CarouselVisibleImpression>({
      event: 'custom_event',
      event_category: carouselType as LinkCarouselType,
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
};
